import React from 'react';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { useUser } from './UserContext';
import WelcomeCard from './WelcomeCard';
import SectionCard from './SectionCard';

const Contests = () => {
  const { user } = useUser();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      flex: 1, // Takes up remaining space
      paddingTop: '50px',
      paddingBottom: '50px',
    }}>
      <div style={{position: 'absolute', left: '0px', top: '0px', width:'100%', opacity: '10%', pointerEvents: 'none' }}>
        <img src='/mascot.png' alt=''/>
      </div>

      {!user && (
        <WelcomeCard />
      )}

      <SectionCard
        headline="Users"
        text="Snapperish has three types of users: Owners, who administer the club and pay for usage, Contest Administrators who can view and edit all photos in a contest, and Club Members. All user types can participate in contests."
        index={0}
      />

      <SectionCard
        headline="Clubs"
        text="A Snapperish Club has a name and a unique short name that is part of the Snapperish URL. Clubs have one Owner and can have any number of Club Members, dependent on the club subscription. A Contest Administrator is a Club Member who can administer a specific contest."
        index={1}
      />

      <SectionCard
        headline="Photo Contests"
        text="A Snapperish Photo Contest has a name/theme, photo upload start and end dates, voting start and end dates, a winners page, an animated photo display page, a maximum number of photos uploadable per member, a maximum number of votes per member, and a list of Club Members that are Contest Administrators. Contests are open to all Club Members. Photos have a maximum size of 20MB."
        index={2}
      />

      <SectionCard
        headline="Contest Voting"
        text="One of the unique things about Snapperish is the voting algorithm. Each Club Member will see a list of photos that they can vote on, but that list is randomized for each Club Member: they have a unique sort of all photos, different from all other members but unchanging for them! This prevents the bias that can occur when photos are listed in the same order for voting for everyone. Only Owners and Contest Administrators can see the uploader and photographer until the end of the contest."
        index={3}
      />

      <SectionCard
        headline="Contest Completion"
        text="A Snapperish contest includes a voting end date and a checkbox to show the contest results. The Owner and Contest Administrators can view the winners at any time during or after the voting period, and the checkbox allows them to announce the winners prior to them being made available on Snapperish. Photos and all their information and votes are made available as a downloadable archive to the Owner and Contest Administrators."
        index={4}
      />

      <SectionCard
        headline="Photo Galleries"
        text="In addition to contests, Snapperish clubs can host Photo Galleries — a permanent, always-visible shared photo space for club members. Galleries have no voting or deadlines: members can upload photos at any time (up to the per-member limit for the club tier), and all gallery photos are visible to all club members immediately. Owners and Gallery Moderators can remove any photo; members can remove their own. Galleries are a great way to keep your club engaged between contests."
        index={5}
      />

      <SectionCard
        headline="CONTENT NOTICE"
        text={<>Snapperish supports lawful photo contests only. Photos containing nudity, violence, exploitative or any other explicit content are prohibited and will be immediately removed and the user suspended. Violations will be reported to Club owners, Snapperish staff, and may be reported to authorities. See our <Link to="/acceptableuse" style={{ color: 'inherit', textDecoration: 'underline' }}>Acceptable Use Policy</Link> for complete guidelines.</>}
        index={4}
      />
    </Box>
  );
};

export default Contests;